<template>
    <div v-if="isPc" class="bank-logos">
        <div v-if="imgList" class="logo-row">
            <img v-for="(item, index) in imgList.slice(0, 4)" :key="'one'+index" :src="item.bankImage + '.webp'"
                alt="" class="logo-image" loading="lazy" />
        </div>
        <div v-if="imgList" class="logo-row">
            <img v-for="(item, index) in imgList.slice(4, 8)" :key="'two'+index" :src="item.bankImage + '.webp'"
                alt="" class="logo-image2" loading="lazy" />
        </div>
    </div>
    <div v-else class="mob-bank-logos">
        <div v-if="imgList" class="logos">
            <img v-for="(item, index) in imgList" :key="'one'+index" :src="item.bankMobImage + '.webp'"
                alt="" class="mob-logo-image" loading="lazy" />
        </div>
    </div>
</template>

<script>
import { dataReport } from "../../../../../../utils/report";
export default {
    props: {
        isPc: {
            type: Boolean,
            default: true
        },
        bankInfo: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
        };
    },
    computed: {
        imgList() {
            return this.bankInfo[1]?.map(item => ({
                bankImage: item.img,
                bankMobImage: item.img_mob
            }))
        }
    },
    methods: {
        handleExposure() {
            if(this.isPc){
                dataReport({
                hottag: 'FQL_HOME_WEB_BANK_EXPOSURE',
                eventPosName: '分期乐web首页银行曝光',
                eventType: 1,
            })
            }
            else{
                dataReport({
                hottag: 'FQL_HOME_MOB_BANK_EXPOSURE',
                eventPosName: '分期乐MOB首页银行曝光',
                eventType: 1,
            })
            }
        }
    },
    watch: {
        imgList: {
            handler(newVal, oldVal) {
                if (newVal !== oldVal) {
                    this.handleExposure();
                }
            },
            immediate: true
        }
    },
};
</script>

<style scoped>
.bank-logos {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
}

.logo-row {
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.logo-image {
    width: 294.02px;
    height: 78.14px;
    margin-bottom: 61px;
}

.logo-image2 {
    width: 294.02px;
    height: 78.14px;
    margin-bottom: 0;
}

.mob-bank-logos {
    display: flex;
    width: 91%;
    justify-content: space-between;
    align-items: center;
    border-radius: 4px;
    border: 1px solid #FFF;
    background: linear-gradient(180deg, rgba(175, 215, 255, 0.50) -23.31%, #FFF 14.83%);
    padding-top: 30px;
    padding-bottom: 14px;
}

.logos{
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
}

.mob-logo-image {
    width: 150.5px;
    height: 39.95px;
    margin-bottom: 16px;
}
</style>